// relative
import type { EditMeterDisplayNameFormValues } from './editMeterDisplayNameForm.schema';

export function toEditMeterDisplayNameFormValues(
  initialDisplayName?: string | null,
): EditMeterDisplayNameFormValues {
  return {
    displayName: initialDisplayName ?? '',
  };
}
